export default "__VITE_ASSET__kFy7JkoC__"